import { rootApi } from '../../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['Lanes'],
});
export const parkingLaneApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findAllLanes: builder.query({
      query: () => `lanes/`,
      providesTags: ['Lanes'],
    }),
    findLanesById: builder.query({
      query: (id) => `lanes/${id}/`,
      providesTags: (result, error, arg) => {
        return result ? [{ type: 'Lanes', id: result.id }] : ['Lanes'];
      },
    }),
    findYardByLocationmaster: builder.query({
      query: () => ({
        url: `location_masters/?ordering=short_name&location_type__code=004`,
        method: 'GET',
      }),
      invalidatesTags: ['Lanes'],
    }),

    findCategoryForTypeLanes: builder.query({
      query: () => ({
        url: `categories/?category_code=16`,
        method: 'GET',
      }),
      invalidatesTags: ['Lanes'],
    }),

    createLanes: builder.mutation({
      query: (body) => ({
        url: `lanes/`,
        method: 'POST',
        body: body,
      }),
      invalidatesTags: ['Lanes'],
    }),

    updateLanes: builder.mutation({
      query: (body) => ({
        url: `lanes/${body.id}/`,
        method: 'PATCH',
        body: body,
      }),
      invalidatesTags: ['Lanes'],
    }),

    deleteLanes: builder.mutation({
      query: (Lanes) => ({
        url: `lanes/${Lanes.id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Lanes'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindAllLanesQuery,
  useFindLanesByIdQuery,
  useFindYardByLocationmasterQuery,
  useFindCategoryForTypeLanesQuery,

  useCreateLanesMutation,
  useUpdateLanesMutation,
  useDeleteLanesMutation,
} = parkingLaneApi;
